<i class="{{ icon() }}"></i>
<span
  #input
  #inputTooltip="ngbTooltip"
  class="tag-value"
  [contentEditable]="focus ? 'plaintext-only' : 'false'"
  [attr.disabled]="!!content()"
  (click)="onClick(); inputTooltip.close()"
  (input)="value.set(input.innerText.trim())"
  [attr.placeholder]="(content() ? (placeholder() ?? '') : (inputPlaceholder() ?? '')) | translate"
  (focusout)="focus = false; localValue.set(input.innerText.trim())"
  (keydown.enter)="$event.preventDefault(); input.blur()"
  [innerText]="(display() ?? '' | translate) || localValue()"
  [ngbTooltip]="content() ? contentTooltip : ('search.smart-search-prompt.edit-tag' | translate)"
  [disableTooltip]="!!(content() && !tooltip()) || !displayTooltip() || focus"
  [openDelay]="500"
  tooltipClass="simple-tooltip max-m"
  [placement]="input.offsetHeight > 24 ? 'right' : 'top'"
  container="body"
></span>
@if (removable()) {
  <i class="delete-tag ph ph-x" (click)="onDelete()"></i>
}
<ng-template #contentTooltip>
  <span [innerHTML]="tooltip() ?? '' | translate"></span>
</ng-template>
